module.exports = __webpack_public_path__ + "static/media/xmg.0076a883.svg";